import {toPng} from 'html-to-image';
import {jsPDF} from 'jspdf';

export const getCapitalizeString = (s) => {
  return s[0].toUpperCase() + s.slice(1);
};

export const getFormatedPhoneNumber = (phone) => {
  const phoneString = String(phone);
  const phoneLength = phoneString.length;

  const formatedPhoneNumber =
    '+' +
    phoneString.substring(0, phoneLength - 10) +
    phoneString
      .substring(phoneLength - 10, phoneLength)
      .replace(/(\d{3})(\d{3})(\d{4})/, ' ($1) $2 - $3');

  return formatedPhoneNumber;
};

export const generatePDF = async (divid, name) => {
  try {
    const dom = document.getElementById(divid);

    const dataUrl = await toPng(dom);

    const img = new Image();
    img.crossOrigin = 'annoymous';
    img.src = dataUrl;
    img.onload = () => {
      // Initialize the PDF.
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'in',
        format: [5.5, 8.5],
      });

      // Define reused data
      const imgProps = pdf.getImageProperties(img);
      const imageType = imgProps.fileType;
      const pdfWidth = pdf.internal.pageSize.getWidth();

      // Calculate the number of pages.
      const pxFullHeight = imgProps.height;
      const pxPageHeight = Math.floor((imgProps.width * 8.5) / 5.5);
      const nPages = Math.ceil(pxFullHeight / pxPageHeight);

      // Define pageHeight separately so it can be trimmed on the final page.
      let pageHeight = pdf.internal.pageSize.getHeight();

      // Create a one-page canvas to split up the full image.
      const pageCanvas = document.createElement('canvas');
      const pageCtx = pageCanvas.getContext('2d');
      pageCanvas.width = imgProps.width;
      pageCanvas.height = pxPageHeight;

      for (let page = 0; page < nPages; page++) {
        // Trim the final page to reduce file size.
        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
          pageCanvas.height = pxFullHeight % pxPageHeight;
          pageHeight = (pageCanvas.height * pdfWidth) / pageCanvas.width;
        }
        // Display the page.
        const w = pageCanvas.width;
        const h = pageCanvas.height;
        pageCtx.fillStyle = 'white';
        pageCtx.fillRect(0, 0, w, h);
        pageCtx.drawImage(img, 0, page * pxPageHeight, w, h, 0, 0, w, h);

        // Add the page to the PDF.
        if (page) pdf.addPage();

        const imgData = pageCanvas.toDataURL(`image/${imageType}`, 1);
        pdf.addImage(imgData, imageType, 0, 0, pdfWidth, pageHeight);
      }

      // Output / Save
      pdf.save(`${name}.pdf`);
    };
  } catch (error) {
    console.log('error', error);
  }
};

export const getSelectionboxOptions = (optionArray) =>
  Object.entries(optionArray).map(([key, value]) => ({
    value: key,
    label: value,
  }));

export const dummyRequeset = (data) =>
  new Promise((res) => {
    setTimeout(() => {
      res(data);
    }, 300);
  });

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const buildLocation = (...places) =>
  [...places].filter(Boolean).join(', ');

export const buildUserName = (firstName, lastName) =>
  `${firstName} ${lastName}`;

export const objToArrayKeyValue = (obj) => Object.entries(obj);

export const swapKeyValues = (obj) =>
  Object.fromEntries(Object.entries(obj).map((a) => a.reverse()));
